import { createContext } from 'react';

import { useEppoFeatureFlag } from '@/context/hooks/useInitializeEppo';

// use for future feature flags
export const StudioFeatureFlagsContext = createContext({
  enableMarkdownInStudio: false,
  showGraphZoomControls: false,
});

export const useStudioFeatureFlags = () => {
  const { value: showGraphZoomControls } = useEppoFeatureFlag({
    featureFlag: 'Studio-Graph-Zoom-Controls',
    flagType: 'boolean',
    defaultValue: false,
  });
  return { showGraphZoomControls: !!showGraphZoomControls };
};
